var map = {
	"./a.jpeg": 1125,
	"./b.jpeg": 44132,
	"./beginners_coding_banner.jpeg": 50391,
	"./c.jpeg": 76875,
	"./d.jpeg": 32426,
	"./datacodeheader1.jpeg": 91305,
	"./datacodeheader2.jpeg": 42568,
	"./e.jpeg": 35377,
	"./f.jpeg": 87088,
	"./g.jpeg": 60487,
	"./h.jpeg": 71494,
	"./i.jpeg": 19181,
	"./j.jpeg": 16300,
	"./k.jpeg": 92979,
	"./l.jpeg": 66898,
	"./m.jpeg": 39910,
	"./n.jpeg": 70136,
	"./o.jpeg": 81679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39537;